<form class="p-5 flex flex-col gap-4" [formGroup]="slideForm">
  <div class="flex justify-between ">
    <div wunInputContainer>
      <label>Nome</label>
      <input wunInput black type="text" formControlName="name">
    </div>
    <div>
      <wun-toggle formControlName="visible" [options]="sliderOptions" label="Stato"></wun-toggle>
    </div>
  </div>
  <div class="flex gap-4 justify-end">
    <button wunButton primary disabled>Rimuovi selezionati</button>
    <wun-file-uploader (currentMediaChange)="fileSelected($event)">
      <ng-template #triggerElement  let-trigger="trigger">
        <button wunButton primary (click)="trigger()">Carica file</button>
      </ng-template>
    </wun-file-uploader>
  </div>
  <div>
    <div>Slides</div>
    <div>
      @for (media of medias(); track media.id) {
        <div class="flex gap-4 items-center p-4 justify-between" [class.bg-gray-100]="$even" [class.bg-gray-200]="$odd">
          <div class="flex items-center">
            <div>
              <wun-checkbox label="" />
            </div>
            <div>
              <img class="w-40 h-20 object-cover" [src]="media.url">
            </div>
          </div>
          <div class="items-center">
            <button wunButton (click)="deleteMedia(media)">Rimuovi</button>
          </div>
        </div>
      }
    </div>

  </div>
  <div class="flex justify-end">
    <button wunButton primary (click)="save()">Salva</button>
  </div>
</form>
